<template>
  <div>
    <div class="mb-4 flex items-center justify-between">
      <FilterTabs
        label="View by"
        v-model="portfolioFilter"
        :options="tabOptions"
        @change="onTabChange"
      />
      <ExportMenu :exports="[
        { type: 'excel', label: 'Current Scores', action: exportCurrentScores, loading: exportingCurrent },
        { type: 'excel', label: 'Score History', action: exportScoreHistory, loading: exportingHistory },
      ]" />
    </div>

    <div class="h-[500px]">
      <template v-if="portfolioFilter === 'My Practices'">
        <Engagement_Table
          v-if="userEntities.length > 0"
          :entity-id="userEntities[0].id"
          :include-descendants="true"
        />
        <div v-else class="text-gray-600 text-sm py-4">
          No entities assigned to your user account.
        </div>
      </template>

      <Engagement_Table v-else-if="portfolioFilter === 'All Practices'" />
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Engagement_Table from '@/components/Lists/Engagement_Table.vue'
import ExportMenu from '@/components/widgetcomponents/library/ExportMenu.vue'
import FilterTabs from '@/components/widgetcomponents/library/FilterTabs.vue'
import { exportToExcel } from '@/utils/exportArraytoXlsx'
import { FEATURES } from '@/constants/features';
import { canAccessFeature } from '@/utils/access';

export default {
  name: 'TabbedEngagementTable',
  components: {
    Engagement_Table,
    ExportMenu,
    FilterTabs,
  },
  props: {
    settings: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    const localStorageKey = this.settings?.localStorage_key || 'engage_engagement_tab'
    const defaultTab = this.settings?.default_tab || 'My Practices'

    return {
      userEntities: [],
      portfolioFilter: localStorage.getItem(localStorageKey) || defaultTab,
      exportingCurrent: false,
      exportingHistory: false,
    }
  },
  computed: {
    tabOptions() {
      return [
        { value: 'My Practices', label: 'My Practices' },
        ...(canAccessFeature(FEATURES.COMPONENT_PRACTICE_PARTNER_ALL)
          ? [{ value: 'All Practices', label: 'All Practices' }]
          : []),
      ]
    },
    localStorageKey() {
      return this.settings?.localStorage_key || 'engage_engagement_tab'
    },
    exportParams() {
      const params = {}
      if (this.portfolioFilter === 'My Practices' && this.userEntities.length > 0) {
        params.parent_entity_id = this.userEntities[0].id
      }
      return params
    }
  },
  methods: {
    async fetchUserEntities() {
      try {
        const response = await axios.get('/api/entities/', {
          params: { linked_user_id: 'me' }
        })
        const results = response.data.results || response.data
        this.userEntities = results
      } catch (error) {
        console.error('Error fetching user entities:', error)
        this.userEntities = []
      }
    },
    onTabChange(value) {
      localStorage.setItem(this.localStorageKey, value)
    },
    async exportCurrentScores() {
      this.exportingCurrent = true
      const response = await axios.get('/api/entity-engagement-scores/export-current/', {
        params: this.exportParams
      })
      if (response.data.length) {
        const today = new Date().toISOString().slice(0, 10)
        await exportToExcel(response.data, `Engagement_Scores_${today}.xlsx`, {
          sheetName: 'Current Scores',
          columnWidths: { 'Practice': 280, 'Latest Comment': 350 }
        })
      }
      this.exportingCurrent = false
    },
    async exportScoreHistory() {
      this.exportingHistory = true
      const response = await axios.get('/api/entity-engagement-scores/export-history/', {
        params: this.exportParams
      })
      if (response.data.length) {
        const today = new Date().toISOString().slice(0, 10)
        await exportToExcel(response.data, `Engagement_Score_History_${today}.xlsx`, {
          sheetName: 'Score History',
          columnWidths: { 'Practice': 280, 'Comment': 350 }
        })
      }
      this.exportingHistory = false
    }
  },
  async mounted() {
    await this.fetchUserEntities()
  }
}
</script>
